const initialState = [];

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SUCCESS_USERS_FIND_ALL':
      return action.payload;
    case 'FAILED_USERS_FIND_ALL':
      return [];
    default:
      return state;
  }
}
